import React from 'react';
import { Portal } from '@chakra-ui/react';
import FsLightbox from 'fslightbox-react';

// @sources - ['url','url',<iframe>]
// @customAttributes - [alt...]
// @type - 'image', 'video', 'youtube'
const LightboxComponent = ({ isOpen, sources, thumbsIcons, customAttributes, type }) => {
  return (
    <FsLightbox
      toggler={isOpen}
      sources={sources}
      thumbsIcons={thumbsIcons}
      customAttributes={customAttributes}
      type={type}
    />
  );
};

export default {
  component: Portal,
  children: ({ isOpen, sources, type, thumbsIcons, customAttributes }) => {
    return {
      component: LightboxComponent,
      props: {
        isOpen: isOpen,
        sources: sources,
        type: type,
        thumbsIcons: thumbsIcons,
        customAttributes: customAttributes,
      },
    };
  },
};
